import styles from "./ProgressBar.module.css";

export function ProgressBar({ value, max = 100, label, tone = "honey" }) {
  const pct = Math.min(100, Math.max(0, (value / max) * 100));
  return (
    <div>
      {label && <div className={styles.label}>{label}</div>}
      <div className={styles.track} role="progressbar" aria-valuenow={value} aria-valuemin={0} aria-valuemax={max}>
        <div className={[styles.fill, styles[tone]].join(" ")} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
